module.exports = __webpack_public_path__ + "static/media/redis-badge.3458f764.svg";